import { IconArrow } from 'components/Shared/Icon';
import styles from './quickguide.scss';

interface QuickguideProps {
  text: string;
  url: string;
}

export const Quickguide = ({ text, url }: QuickguideProps) => {
  return (
    <a href={url} className={styles.quickguide}>
      <span className={styles.title}>{text}</span>
      <IconArrow className={styles.arrow} />
    </a>
  );
};
